module.exports = __webpack_public_path__ + "img/qtum.7abee0ba.png";